import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
import { bringOutFieldsConfig } from '../formdataAndRules.js'
import { verifyDate } from '../../../../../../../utils/common.js'
import { getSysLicensePlateNo, getSupplierCarInfoDetail, getLengthByCode} from '../../../../../../../api/register/vehicle.js'
import { getSysControlParamByCode, getOcrInfoByUrl } from '../../../../../../../api/register/vehicle.js'
import { CAR_OWNER_TYPE, AUDIT_STATUS, REGISTER_SOURCE } from '../../../../../../../constant/constant.js'
import { dictWithUrl } from '@/components/lots/api'
import { uploadList } from '../uploadListConfig.js'
import { debounce, isEmpty } from 'lodash'
import { getSysControlParamList } from '../../../../../../../api/toDo/sysParamsConfig.js'
import { carInnerLwhVerify } from '../../../../../../../constant/formRegular.js'
let inputDebounce = null
export const INIT_OCR_RESULT_MAP = {
    carDrivingFileUrl: {
        fieldName: 'carDrivingFileUrl',
        warnInfos: '',
        riskType: '',
        editTool: '',
        classificationNumber: 0, //当前证件的分类识别调用次数
        classificationErrorNumber: 0, //当前证件的分类识别错误次数
        continueUseNumber: 0, //当前证件选择继续使用的次数
        isUseError: '0',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    carDrivingBottomFileUrl: {
        fieldName: 'carDrivingBottomFileUrl',
        warnInfos: '',
        riskType: '',
        editTool: '',
        classificationNumber: 0, //当前证件的分类识别调用次数
        classificationErrorNumber: 0, //当前证件的分类识别错误次数
        continueUseNumber: 0, //当前证件选择继续使用的次数
        isUseError: '0',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    roadTransportFileUrl: {
        fieldName: 'roadTransportFileUrl',
        warnInfos: '',
        riskType: '',
        editTool: '',
        classificationNumber: 0, //当前证件的分类识别调用次数
        classificationErrorNumber: 0, //当前证件的分类识别错误次数
        continueUseNumber: 0, //当前证件选择继续使用的次数
        isUseError: '0',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    carDrivingEndTime: {
        fieldName: 'carDrivingEndTime',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    roadTransportEndTime: {
        fieldName: 'roadTransportEndTime',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    trailerDrivingEndDate: {
        fieldName: 'trailerDrivingEndDate',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    length: {
        fieldName: 'length',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    lengthNameCn: {
        fieldName: 'lengthNameCn',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    licensePlateNo: {
        fieldName: 'licensePlateNo',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    carOwner: {
        fieldName: 'carOwner',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    totalWeight: {
        fieldName: 'totalWeight',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    grossWeight: {
        fieldName: 'grossWeight',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    lengthMaxWeight: {
        fieldName: 'lengthMaxWeight',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    energyType: {
        fieldName: 'energyType',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    carOwnerType: {
        fieldName: 'carOwnerType',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    loadingVolume: {
        fieldName: 'loadingVolume',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    insideLength: {
        fieldName: 'insideLength',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    insideWidth: {
        fieldName: 'insideWidth',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    insideHeight: {
        fieldName: 'insideHeight',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    licensePlateColor: {
        fieldName: 'licensePlateColor',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    roadTransportNo: {
        fieldName: 'roadTransportNo',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    trafficInsuranceEndTime: {
        fieldName: 'trafficInsuranceEndTime',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    businessInsuranceEndTime: {
        fieldName: 'businessInsuranceEndTime',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    affiliatedEndTime: {
        fieldName: 'affiliatedEndTime',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    trailerLicensePlateNo: {
        fieldName: 'trailerLicensePlateNo',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    carOwnerPhone: {
        fieldName: 'carOwnerPhone',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    mainVehicleType: {
        fieldName: 'mainVehicleType',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    mainIssueDate: {
        fieldName: 'mainIssueDate',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    mainRegisterDate: {
        fieldName: 'mainRegisterDate',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    carDrivingAuthority: {
        fieldName: 'carDrivingAuthority',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    mainVin: {
        fieldName: 'mainVin',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    lengthInteriorLength: {
        fieldName: 'lengthInteriorLength',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    lengthInteriorWidth: {
        fieldName: 'lengthInteriorWidth',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    lengthInteriorHeight: {
        fieldName: 'lengthInteriorHeight',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    commonDriver: {
        fieldName: 'commonDriver',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    commonDriverPhone: {
        fieldName: 'commonDriverPhone',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    axlesNum: {
        fieldName: 'axlesNum',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    vehicleEmissionsStandards: {
        fieldName: 'vehicleEmissionsStandards',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    otherInformation: {
        fieldName: 'otherInformation',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    otherInformationExplain: {
        fieldName: 'otherInformationExplain',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    photosVehicleFileUrl: {
        fieldName: 'photosVehicleFileUrl',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
    carAge: {
        fieldName: 'carAge',
        ocrValue: '',
        systemValue: '',
        changeType: '2'
    },
}
export default {
    // 获取字典数据
    getDictData() {
        dictWithUrl('SRM_ENERGY_TYPE,SRM_VEHICLE_TYPE').then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data || {}
            }
        })
    },
    // 初始化编辑时的数据
    initFormData(data) {
        this.ocrResultMap = cloneDeep(INIT_OCR_RESULT_MAP)
        if(['30', '80'].includes(data.approvalStatus) && data.paramFieldList && data.paramFieldList.length){
            //如果是撤回/驳回状态，需要取paramFieldList赋值，防止再次原封不动提交出现免审的情况
            const obj = data.paramFieldList.reduce((t,v) => {
                t[v.fieldName] = cloneDeep(v)
                return t
            }, {})
            this.ocrResultMap = {
                ...this.ocrResultMap,
                ...obj,
            }
        }
        
        //重置ocr图片质量欠佳提示次数
        this.ocrQualityCount = {
            carDrivingFileUrl: 0,
            carDrivingBottomFileUrl: 0,
            roadTransportFileUrl: 0,
            trailerDrivingFileUrl: 0,
        }
        Object.keys(data).forEach(k => {
            if (k === 'otherInformation') {
                if(data[k]){
                    if(Array.isArray(data[k])){
                        this.formData[k] = data[k]
                    }else{
                        this.formData[k] = data[k].split(',')
                    }
                }else{
                    this.formData[k] = []
                }
            } else if (['carDrivingEndTime', 'mainIssueDate', 'mainRegisterDate', 'roadTransportEndTime', 'affiliatedEndTime', 'trailerDrivingEndDate', 'trafficInsuranceEndTime', 'businessInsuranceEndTime'].includes(k) && data[k]) {
                // 接口返回了 YYYY-MM-DD 00:00:00 格式，需要转换成YYYY-MM-DD，否则与ocrData作对比会有差异
                this.formData[k] = dayjs(data[k]).format('YYYY-MM-DD')
            } else if (['insideHeight', 'insideLength', 'insideWidth', 'loadingVolume'].includes(k) && !this.isEmpty(data[k])){
                //这几个字段后端返回是number类型，但是输入框的值为string，需提前转换为string用于表单变化比较
                this.formData[k] = data[k].toString()
            } else {
                this.formData[k] = data[k]
            }
        })
        this.setFileData(data)
        this.setOcrData()
        this.$nextTick(() => {
            this.$refs.formRef.clearValidate()
        })
        //备份表单字段用于编辑提交时比对校验
        this.backupFormData = JSON.parse(JSON.stringify(this.formData))
        // // 编辑时将车辆详情内径长宽高暂存，提交时作对比
        // this.innerDiameterData.insideLength = data.insideLength
        // this.innerDiameterData.insideWidth = data.insideWidth
        // this.innerDiameterData.insideHeight = data.insideHeight
        this.showAbnormalFlag = {
            carDrivingFileUrl: this.formData.abnormalFlag ? this.formData.abnormalFlag.indexOf('1') > -1 : false,
            carDrivingBottomFileUrl: this.formData.abnormalFlag ? this.formData.abnormalFlag.indexOf('1') > -1 : false,
            roadTransportFileUrl: this.formData.abnormalFlag ? this.formData.abnormalFlag.indexOf('2') > -1 : false,
            photosVehicleFileUrl: this.formData.abnormalFlag ? this.formData.abnormalFlag.indexOf('3') > -1 : false,
            trailerDrivingFileUrl: this.formData.abnormalFlag ? this.formData.abnormalFlag.indexOf('4') > -1 : false,
            trailerDrivingVerifyFileUrl: this.formData.abnormalFlag ? this.formData.abnormalFlag.indexOf('4') > -1 : false,
        }
    },
    onOutsideDiameterChange() {
        inputDebounce && inputDebounce.cancel()
        inputDebounce = debounce(() => {
            const lengthList = this.lengthCodeList
            const length = this.formData.length // 车型编码
            const outLength = this.formData.lengthInteriorLength - 0 // 车外径长度
            const outWidth = this.formData.lengthInteriorWidth - 0 // 车外径宽度
            if (outLength === '' || outWidth === '') {
                return false
            }
            
            if (!(outLength >= 5.8 && outLength <= 6.0) || outWidth < 2.3 ) {
                if (lengthList.includes(length)) {
                    this.formData.length = ''
                    this.formData.lengthNameCn = ''
                }
            }
            else if (!(outLength >= 5.8 && outLength <= 6.0) || outWidth >= 2.3 ) {
                if (!lengthList.includes(length)) {
                    this.formData.length = ''
                    this.formData.lengthNameCn = ''
                }
            }
        }, 1500)
        inputDebounce()
    },
    onInsideWidthBlur(prop) {
        // 重新校验装载方量
        this.$refs.formRef.validateField('loadingVolume', error => {
            if (!error) {
                // 校验通过后的操作
            } else {
                return false
            }
        })
    },
    // 将证件信息(fileId, fileName, fileUrl)存储下来
    setFileData(data) {
        [
            'carDrivingFile',
            'carDrivingBottomFile',
            'photosVehicleFile',
            'roadTransportFile',
            'affiliatedFile',
            'trafficInsuranceFile',
            'businessInsuranceFile',
            'trailerDrivingFile',
            'trailerDrivingVerifyFile',
        ].forEach(k => {
            // 法人时，交强险、商业保险 不进行遍历赋值
            // if (this.isLegalPersonSupplier && ['trafficInsuranceFile', 'businessInsuranceFile'].includes(k)) {
            //     return false
            // }
            this.uploadForm[`${k}Url`] = data[`${k}TemUrl`] || data[`${k}Url`] || this.formData[`${k}Url`]
            const fileType = this.uploadForm[`${k}Url`]
                ? this.uploadForm[`${k}Url`].slice(this.uploadForm[`${k}Url`].lastIndexOf('.'))
                : ''
            this.showPdfDocxFileCoverImg(
                {
                    type: fileType.replace('.', ''),
                    downUrl: this.uploadForm[`${k}Url`],
                    localFileName: data[`${k}Name`] || this.formData[`${k}Name`] || this.imgExample[`${k}Name`] || '',
                },
                `${k}Url`,
            )
            this.fileObj[`${k}Url`] = {
                id: data[`${k}Id`] || this.formData[`${k}Id`] || this.imgExample[`${k}Id`] || '',
                localFileName: data[`${k}Name`] || this.formData[`${k}Name`] || this.imgExample[`${k}Name`] || '',
                downUrl:
                    data[`${k}TemUrl`]
                    || data[`${k}Url`]
                    || this.formData[`${k}Url`]
                    || this.imgExample[`${k}Url`]
                    || '',
            }
        })
    },
    setOcrData() {
        const ocrKeys = Object.keys(this.ocrData)
        ocrKeys.forEach(key => {
            this.ocrData[key] = this.formData[key]
        })
    },
    ocrHasChange() {
        const ocrKeys = Object.keys(this.ocrData)
        // const formTemp = {}
        // ocrKeys.forEach(key => {
        //     formTemp[key] = this.formData[key]
        // })
        // console.log(formTemp)
        // console.log(this.ocrData)
        // console.log('-----------')
        return ocrKeys.some(key => this.ocrData[key] !== this.formData[key])
    },
    // 车型选中高级组件后回调
    async setLengthAdvanceValue(array, data) {
        let flag = false;
        const outLength = this.formData.lengthInteriorLength // 车外径长度
        const outWidth = this.formData.lengthInteriorWidth // 车外径宽度
        if (outLength !== '' && outWidth !== '') {
            await this.validateLength(data).then(resFlag => {
                flag = resFlag;
            })
        }
        if (flag) {
            return false
        }
        array.forEach(k => {
            //内径长宽高有值才填充
            if(['insideLength', 'insideWidth', 'insideHeight'].includes(k) && this.isEmpty(data[k])){
                return
            }
            // 数字类型的字段有值时转化为字符串格式，其他字段不处理
            const val = ['insideLength', 'insideWidth', 'insideHeight','axlesNum', 'loadingVolume'].includes(k) && !this.isEmpty(data[k]) ? String(data[k]) : data[k]
            this.$set(this.formData, k, val)
            if(!['length', 'lengthNameCn'].includes(k)){
                //除车型字段外，其他字段的赋值都为system
                this.setOcrAndChangeType(k, this.formData[k], 'systemValue')
            }
        })

        // 重新校验车型
        this.$refs.formRef.validateField('lengthNameCn')
    },
    async getLengthTipData() {
        let lengthTipList = []
        const res = await this.getSysControlParamByCodeData()
        if (res && +res.code === 0) {
            const resData = res.data
            if (resData) {
                const newData = JSON.parse(resData)
                if (Array.isArray(newData)) {
                    lengthTipList = newData
                }
            }
        }
        this.lengthTipList = lengthTipList
        this.lengthCodeList = lengthTipList.map(item => item.cdegCode)
    },
    getLengthByCodeData(lengthCode) {
        const params = {
            pageSize: 10,
            pageNo: 1,
            cdegCode: lengthCode,
        }
        return getLengthByCode(params)

    },
    // eslint-disable-next-line complexity
    async validateLength(data) {
        const length = data.length
        const outLength = this.formData.lengthInteriorLength - 0 // 车外径长度
        const outWidth = this.formData.lengthInteriorWidth - 0 // 车外径宽度
        // 外径长度是 5.8 -6.0之间，外径宽度≥2.3，
        // 车型只允许选择 D0119【4.2M新能源宽体】，D0120【4.2M宽体厢车】
        let tipText = '';
        const res = await this.getSysControlParamByCodeData()
        if (res && +res.code === 0) {
            const resData = res.data
            if (resData) {
                const newDataList = JSON.parse(resData)
                // eslint-disable-next-line max-depth
                if (Array.isArray(newDataList)) {
                    this.lengthTipList = newDataList;
                    this.lengthCodeList = newDataList.map(item => item.cdegCode);
                    tipText = this.setTipText(newDataList)
                }
            }
        }
        if (outLength >= 5.8 && outLength <= 6.0 && outWidth >= 2.3 && !this.lengthCodeList.includes(length)) {
            if (tipText) {
                this.$message.warning(`外径长度 5.8 -6.0之间 , 外径宽度≥2.3，只能选择 ${tipText}`)
                this.$set(this.formData, 'lengthNameCn', '')
                this.$set(this.formData, 'length', '')
                this.$nextTick(() => {
                    this.$refs.lengthAdvance.value = ''
                })
            }
            return true
        } else if ((!(outLength >= 5.8 && outLength <= 6.0) && this.lengthCodeList.includes(length)) || (outWidth < 2.3 && this.lengthCodeList.includes(length))) {
            this.$message.warning(`选择 ${tipText}，只能填写外径长度 5.8 -6.0之间 , 外径宽度≥2.3`)
            this.$set(this.formData, 'lengthNameCn', '')
            this.$set(this.formData, 'length', '')
            this.$nextTick(() => {
                this.$refs.lengthAdvance.value = ''
            })
            return true
        } else {
            return false
        }
    },
    setTipText(newDataList) {
        let tipText = ''
        for (let i = 0; i < newDataList.length; i++) {
            const item = newDataList[i];
            if (i === newDataList.length - 1) {
                tipText += `${item.actualVechile}/${item.cdegCode}车型`
            } else {
                tipText += `${item.actualVechile}/${item.cdegCode}车型、`
            }
        }
        return tipText
    },

    getSysControlParamByCodeData() {
        const params = {
            controlCode: 'checkLengthForWidthTheLengthList',
        }
        return getSysControlParamByCode(params)
    },
    // 选中高级组件后回调
    setAdvanceValue(array, data) {
        array.forEach(k => {
            // 轴数axlesNum有值时转化为字符串格式，其他字段不处理
            const val = k === 'axlesNum' && data[k] ? String(data[k]) : data[k]
            this.$set(this.formData, k, val)
        })
    },
    // 选中下拉选项后回调
    handleMSelectValue(prop, val) {
        this.$set(this.formData, prop, val)
    },
    // 设置主要能源类型字段
    setEnergyType(inspectionRecord) {
        const target = Object.entries(this.dictData.SRM_ENERGY_TYPE).find(v => v[1] === inspectionRecord)
        if (target) {
            this.formData.energyType = target[0]
            this.setOcrAndChangeType('energyType', this.formData.energyType, 'ocrValue')
            this.ocrData.energyType = this.formData.energyType
        }
    },
    // 展示pdf或者word文件上传后的封面图片
    showPdfDocxFileCoverImg(data, flag) {
        if (['docx', 'doc'].includes(data.type)) {
            this.uploadForm[flag] = require('./example/file-word.png')
        } else if (data.type === 'pdf') {
            this.uploadForm[flag] = require('./example/file-pdf.png')
        } else {
            this.uploadForm[flag] = data.downUrl
        }
    },
    setOcrAndChangeType(prop, value, type){
        if(this.ocrResultMap[prop]){
            this.ocrResultMap[prop][type] = value
        }
    },
    async getControlSwitch(controlCode, prop){
        await getSysControlParamList({ controlCode }).then(res => {
            if (res && +res.code === 0 && res.data.list && res.data.list[0]) {
                this[prop] = res.data.list[0].controlValue === 'true'
            }
        })
    },
    delFile(key){
        this.formData[`${key}Url`] = ''
        this.formData[`${key}Name`] = ''
        this.formData[`${key}Id`] = ''
        this.uploadForm[`${key}Url`] = ''
        this.fileObj[`${key}Url`] = {id: '', localFileName: '', downUrl: ''}
        //当有异常标识时,删除文件需要把异常标识清空
        this.showAbnormalFlag[`${key}Url`] = false
    },
    aiCounter(type, counter){
        const url = type.split('#')[1]
        if(this.ocrResultMap[url]) {
            this.ocrResultMap[url][counter]++
        }
    },
    // 文件上传成功后回调
    async handleUploadSuccess(result) {
        const name = result.flag.split('#')[0]
        const url = result.flag.split('#')[1]
        const id = result.flag.split('#')[2]
        const responseData = result.data.ossResult ? result.data.ossResult : result.data.data
        let ocrResult = null
        if(result.aiType && result.aiType.includes('电子行驶证') && name === 'carDrivingFileName'){
            //行驶证正副页AI分类为电子行驶证,需要取frontValue
            ocrResult = result.data.frontValue
        }else{
            ocrResult = result.data.ocrResult
        }

        if(result.aiFlag){
            //原来需要ocr的证件因为ai识别有异常，用户选择了普通上传，不走ocr
        }else{
            if(result.aiType &&  (result.aiType.includes('空白年审页') || (url === 'carDrivingBottomFileUrl' && result.aiType.includes('电子行驶证')))){
                //空白年审页或者年审页的AI分类=电子行驶证不走ocr判断
            }else{
                if(!ocrResult && ['carDrivingFileUrl', 'trailerDrivingFileUrl', 'carDrivingBottomFileUrl', 'roadTransportFileUrl'].includes(url) && this.ocrQualityCount[url] < 3){
                    //ocr接口报错，也需要累加ocrQualityCount次数
                    this.ocrQualityCount[url] += 1
                    this.$message.warning(`证件OCR失败，请重新上传图片`)
                    return
                }
                //OCR识别当图片质量有问题时，记录次数，前3次不允许上传
                //图片质量问题：行驶证/挂车行驶证/行驶证年审页-----warn_infos=['shield','fuzzy'], 
                //判断是走老OCR还是新OCR：risk_type字段undefined为老OCR,老OCR不需要校验图片质量问题与risk_type
                //251025版本去掉warn_infos校验!!!!!!
                // const qualityFlag = ocrResult && ['carDrivingFileUrl', 'trailerDrivingFileUrl', 'carDrivingBottomFileUrl'].includes(url) && (ocrResult.warn_infos && (ocrResult.warn_infos.indexOf('shield') > -1 || ocrResult.warn_infos.indexOf('fuzzy') > -1)) && ocrResult.risk_type !== undefined
                // if(ocrResult && qualityFlag && this.ocrQualityCount[url] < 3){
                //     this.ocrQualityCount[url] += 1
                //     this.$message.warning(`上传的证件模糊或图片不齐全，请重新上传。`)
                //     return
                // }
        
    
                //行驶证图片edit_tool有值，图片存在编辑过的风险，需要卡控
                if(ocrResult && ['carDrivingFileUrl', 'trailerDrivingFileUrl', 'carDrivingBottomFileUrl'].includes(url) && ocrResult.edit_tool){
                    await this.getControlSwitch('ocrUploadEditTool', 'editToolSwitch')
                    this.$message.warning(this.editToolSwitch ? `上传的图片存在被编辑过的风险，请重新上传。` : `上传的图片存在被编辑过的风险，请注意风险。`)
                    if(this.editToolSwitch) {
                        //开关打开
                        return 
                    }
                }
    
                //行驶证不需要卡控riskType
                // if(ocrResult && ocrResult.risk_type !== 'normal' && ocrResult.risk_type !== undefined && ['carDrivingFileUrl', 'trailerDrivingFileUrl', 'carDrivingBottomFileUrl'].includes(url)){
                //     await this.getControlSwitch()
                //     this.$message.warning(this.riskTypeSwitch ? `上传的图片不符合合规要求，请重新上传。` : `上传的图片可能不符合合规要求，请注意。`)
                //     if(this.riskTypeSwitch) {
                //         //开关打开
                //         return 
                //     }
                // }
            }
        }
        
        // if (ocrResult) {
            switch (name) {
            case 'carDrivingFileName':
                this.setCarDrivingFileFormData(ocrResult||{})
                //上传完行驶证正副页，需要把行驶证年审页清空
                this.delFile('carDrivingBottomFile')
                break
            case 'carDrivingBottomFileName':
                if(result.aiType && !result.aiType.includes('空白年审页') && !result.aiType.includes('电子行驶证')){
                    //非空白年审页,非电子行驶证才取OCR赋值
                    this.setCarDrivingBottomFileFormData(ocrResult||{})
                }
                break
            case 'roadTransportFileName':
                this.setRoadTransportFileFormData(ocrResult||{})
                break
            case 'trailerDrivingFileName':
                this.setTrailerDrivingFileFormData(ocrResult||{})
                break
            default:
                break
            }
        if(this.ocrResultMap[url]) {
            this.ocrResultMap[url].warnInfos = ocrResult ? ocrResult.warn_infos : ''
            this.ocrResultMap[url].riskType = ocrResult ? ocrResult.risk_type : ''
            this.ocrResultMap[url].editTool = ocrResult ? ocrResult.edit_tool : ''
            this.ocrResultMap[url].isUseError = result.aiFlag ? '1' : '0'
        }
        this.fileObj[url] = responseData
        this.showPdfDocxFileCoverImg(
            {
                type: responseData.type,
                downUrl: responseData.downUrl,
                localFileName: responseData.localFileName,
            },
            url,
        )
        // 设置文件上传成功返回的数据
        this.setResponseFormData(responseData, name, url, id, !!ocrResult)
            // 如果车牌号存在，查询系统数据库中是否有关联司机信息
            if (ocrResult && ocrResult.mainPlateNum && name === 'carDrivingFileName') {
                this.handleQueryLicensePlateNo()
            }
        // }
    },
    // 将上传文件后的回调数据(文件名、文件id、文件url)保存到formData中
    setResponseFormData(data, name, url, id, isOcr) {
        let fileName = data.localFileName
        // ocr识别的文件名添加后缀
        if (isOcr) {
            fileName = fileName + data.downUrl.slice(data.downUrl.lastIndexOf('.'))
        }
        this.$set(this.formData, name, fileName)
        this.$set(this.formData, url, data.downUrl)
        this.$set(this.formData, id, data.id)
        //当有异常标识时,重新上传完文件需要把异常标识清空
        this.showAbnormalFlag[url] = false
    },
    //道路运输证
    setRoadTransportFileFormData(info){
        this.formData.roadTransportNo = info.roadTransportNo
        this.setOcrAndChangeType('roadTransportNo', info.roadTransportNo, 'ocrValue')
        this.formData.roadTransportEndTime = this.transformErrorMonth(verifyDate(info.roadTransportEndTime))
        this.setOcrAndChangeType('roadTransportEndTime', this.formData.roadTransportEndTime, 'ocrValue')
    },
    //挂车行驶证
    async setTrailerDrivingFileFormData(info){
        this.formData.trailerLicensePlateNo = info.mainPlateNum
        this.setOcrAndChangeType('trailerLicensePlateNo', info.mainPlateNum, 'ocrValue')
        //牵引车需要把挂车外径长度+行驶证外径长度=总外径长度
        if (info.size && this.hasTract) {
            const size = info.size.replace('mm', '').split('×')
            //挂车外径长度大于0 行驶证外径长度>0 才相加计算
            let lengthInteriorLength = 0
            if(this.formData.carDrivingFileUrl){
                //有行驶证才获取OCR外径
                try {
                    const res = await getOcrInfoByUrl({downUrl: this.formData.carDrivingFileUrl, type: 'vehicle'})
                    if(res && res.code === '0'){
                        if(res.data.ocrResult && res.data.ocrResult.size){
                            const carSize = res.data.ocrResult.size.replace('mm', '').split('×')
                            lengthInteriorLength = carSize[0] / 1000
                        }else if(res.data.frontValue && res.data.frontValue.size){
                            const carSize = res.data.frontValue.size.replace('mm', '').split('×')
                            lengthInteriorLength = carSize[0] / 1000
                        }
                    }
                }catch(err){}
            }
            if(+size[0] > 0 && lengthInteriorLength > 0){
                this.formData.lengthInteriorLength = String(+((+size[0] / 1000 + +lengthInteriorLength).toFixed(3)))
                this.setOcrAndChangeType('lengthInteriorLength', this.formData.lengthInteriorLength, 'systemValue')
            }
            //牵引车车辆外径 = 挂车外径
            if(+size[1] > 0){
                this.formData.lengthInteriorWidth = String(+size[1] / 1000)
                this.setOcrAndChangeType('lengthInteriorWidth', this.formData.lengthInteriorWidth, 'systemValue')
            }
        }
    },
    //行驶证年审页
    setCarDrivingBottomFileFormData(info){
        // 行驶证有效期至
        // if (info.carDrivingEndTime) {
            this.formData.carDrivingEndTime = info.carDrivingEndTime
            this.setOcrAndChangeType('carDrivingEndTime', this.formData.carDrivingEndTime, 'ocrValue')
        // }
    },
    // 设置上传行驶证正面带出的数据
    async setCarDrivingFileFormData(info) {
        // 车牌号
        if (!this.id) {
            this.formData[bringOutFieldsConfig[0].field] = info.mainPlateNum
        } // 编辑状态不修改了<车牌号>
        //新增编辑都要把车牌号ocrValue存起来
        this.setOcrAndChangeType(bringOutFieldsConfig[0].field, info.mainPlateNum, 'ocrValue')

        bringOutFieldsConfig.forEach((e, i) => {
            if (i > 0) {
                switch (e.type) {
                case 'text':
                    this.formData[e.field] = info[e.field] || ''
                    this.setOcrAndChangeType(e.field, this.formData[e.field], 'ocrValue')
                    break
                case 'weight':
                    this.formData[e.field] = info[e.infoField] ? info[e.infoField].replace('kg', '') : ''
                    this.setOcrAndChangeType(e.field, this.formData[e.field], 'ocrValue')
                    break
                case 'date':
                    this.formData[e.field] = this.transformErrorMonth(verifyDate(info[e.field]))
                    this.setOcrAndChangeType(e.field, this.formData[e.field], 'ocrValue')
                    break
                }
            }
        })

        // 行驶证有效期至
        if (info.vehicle_license_test_valid) {
            //老OCR逻辑vehicle_license_test_valid会包含‘年’字，需要补日期01，新OCR不需要补
            this.formData.carDrivingEndTime = this.transformErrorMonth(
                info.vehicle_license_test_valid.replace('年', '-').replace('月', '-') + (info.vehicle_license_test_valid.indexOf('年') > -1 ? '01' : ''),
            )
            this.setOcrAndChangeType('carDrivingEndTime', this.formData.carDrivingEndTime, 'ocrValue')
        }else{
            this.formData.carDrivingEndTime = ''
            this.setOcrAndChangeType('carDrivingEndTime', this.formData.carDrivingEndTime, 'ocrValue')
        }
        
        // 车辆能源类型
        if (info.inspectionRecord) {
            this.setEnergyType(info.inspectionRecord)
        }
        //当OCR车辆类型包含“牵引”，核定载重量取准牵引总质量，赋值方式为system
        if(info.mainVehicleType && this.dictData['SRM_VEHICLE_TYPE'][info.mainVehicleType].indexOf('牵引') > -1){
            this.formData.lengthMaxWeight = info.grossCombinationWeightRating ? info.grossCombinationWeightRating.replace('kg', '') : ''
            this.setOcrAndChangeType('lengthMaxWeight', this.formData.lengthMaxWeight, 'systemValue')
        }
        //当总质量为空或0时，并且核定载重量有值大于0，并且整备质量有值大于0，那么总质量=核定载重量+整备质量，赋值方式为system
        if((!this.formData.totalWeight || this.formData.totalWeight === '0') && this.formData.lengthMaxWeight > 0 && this.formData.grossWeight > 0){
            this.formData.totalWeight = this.formData.lengthMaxWeight*1 + this.formData.grossWeight*1
            this.setOcrAndChangeType('totalWeight', this.formData.totalWeight, 'systemValue')
        }
        // 如果ocr返回size字段，则拆分长宽高
        if (info.size) {
            const size = info.size.replace('mm', '').split('×')
            if(this.hasTract){
                //牵引车
                if(this.formData.trailerDrivingFileUrl){
                    //有挂车行驶证需要调接口获取挂车行驶证正副页OCR外径
                    let lengthInteriorLength = 0, lengthInteriorWidth = 0
                    try {
                        const res = await getOcrInfoByUrl({downUrl: this.formData.trailerDrivingFileUrl, type: 'trailerVehicle'})
                        if(res && res.code === '0'){
                            if(res.data.ocrResult && res.data.ocrResult.size){
                                const carSize = res.data.ocrResult.size.replace('mm', '').split('×')
                                lengthInteriorLength = carSize[0] / 1000
                                lengthInteriorWidth = carSize[1] / 1000
                            }else if(res.data.frontValue && res.data.frontValue.size){
                                const carSize = res.data.frontValue.size.replace('mm', '').split('×')
                                lengthInteriorLength = carSize[0] / 1000
                                lengthInteriorWidth = carSize[1] / 1000
                            }
                        }
                    }catch(err){}

                    if(+size[0] > 0 && lengthInteriorLength > 0){
                        //行驶证OCR外径长度 与 挂车行驶证OCR外径长度都大于0，触发自动计算
                        this.formData.lengthInteriorLength = String(+((+size[0] / 1000 + +lengthInteriorLength).toFixed(3)))
                        this.setOcrAndChangeType('lengthInteriorLength', this.formData.lengthInteriorLength, 'systemValue')
                        this.setOcrAndChangeType('lengthInteriorLength', String(+size[0] / 1000), 'ocrValue')
                    }else{
                        //挂车行驶证识别不到OCR外径长度，按原逻辑赋值外径长度
                        this.formData.lengthInteriorLength = String(+size[0] / 1000)
                        this.setOcrAndChangeType('lengthInteriorLength', this.formData.lengthInteriorLength, 'ocrValue')
                    }
                    if(lengthInteriorWidth > 0){
                        //挂车行驶证OCR外径宽度大于0，触发自动计算
                        this.formData.lengthInteriorWidth = String(lengthInteriorWidth)
                        this.setOcrAndChangeType('lengthInteriorWidth', this.formData.lengthInteriorWidth, 'systemValue')
                        this.setOcrAndChangeType('lengthInteriorWidth', String(+size[1] / 1000), 'ocrValue')
                    }else{
                        //挂车行驶证识别不到OCR外径宽度，按原逻辑赋值外径宽度
                        this.formData.lengthInteriorWidth = String(+size[1] / 1000)
                        this.setOcrAndChangeType('lengthInteriorWidth', this.formData.lengthInteriorWidth, 'ocrValue')
                    }
                }else{
                    //没有挂车行驶证，按原逻辑赋值
                    this.formData.lengthInteriorLength = String(+size[0] / 1000)
                    this.setOcrAndChangeType('lengthInteriorLength', this.formData.lengthInteriorLength, 'ocrValue')
                    this.formData.lengthInteriorWidth = String(+size[1] / 1000)
                    this.setOcrAndChangeType('lengthInteriorWidth', this.formData.lengthInteriorWidth, 'ocrValue')
                }
            }else{
                //非牵引车,按原逻辑赋值
                this.formData.lengthInteriorLength = String(+size[0] / 1000)
                this.setOcrAndChangeType('lengthInteriorLength', this.formData.lengthInteriorLength, 'ocrValue')
                this.formData.lengthInteriorWidth = String(+size[1] / 1000)
                this.setOcrAndChangeType('lengthInteriorWidth', this.formData.lengthInteriorWidth, 'ocrValue')
            }
            this.formData.lengthInteriorHeight = String(+size[2] / 1000)
            this.setOcrAndChangeType('lengthInteriorHeight', this.formData.lengthInteriorHeight, 'ocrValue')
        }
        // 法人供应商，供应商名称和车辆所有人相同 || 个体供应商，负责人姓名和车辆所有人相同
        if (
            (this.isLegalPersonSupplier && this.supplierName === this.formData.carOwner)
            || (!this.isLegalPersonSupplier && this.principalName === this.formData.carOwner)
        ) {
            this.formData.carOwnerType = CAR_OWNER_TYPE.OWN // 自有
            this.setOcrAndChangeType('carOwnerType', CAR_OWNER_TYPE.OWN, 'systemValue')
        }
        // this.setOcrData({ carOwner: info.carOwner, licensePlateNo: info.mainPlateNum })
        this.ocrData.licensePlateNo = this.formData.licensePlateNo
        this.ocrData.carOwner = this.formData.carOwner
        this.ocrData.lengthMaxWeight = this.formData.lengthMaxWeight
        this.ocrData.grossWeight = this.formData.grossWeight
        this.ocrData.carDrivingEndTime = this.formData.carDrivingEndTime
    },
    // 处理月份识别错误问题
    transformErrorMonth(dateStr) {
        let newDateStr = ''
        if (dateStr) {
            const dateArr = dateStr.split('-')
            if (dateArr.length && Number(dateArr[1]) > 12) {
                dateArr[1] = '12'
                newDateStr = dateArr.join('-')
            } else {
                newDateStr = dateStr
            }
        }
        return newDateStr
    },
    // 预览文件（继承旧版方法）
    previewFile(flag) {
        const allAttachmentList = []
        const rowData = {}
        Object.keys(this.uploadForm).forEach(k => {
            allAttachmentList.push(this.uploadForm[k] ? this.uploadForm[k] : this.imgExample[k])
            rowData.fileId = this.fileObj[flag] ? this.fileObj[flag].id : new Date().getTime()
            rowData.localFileName = this.fileObj[flag]
                ? this.fileObj[flag].localFileName
                : new Date().getTime() + '_' + flag
            rowData.downUrl = this.fileObj[flag] ? this.fileObj[flag].downUrl : this.imgExample[flag]
        })
        this.$emit('preview', { allAttachmentList, rowData })
    },
    // // 点击查看司机信息面板
    // handleViewVehicleInfoPanel() {
    //     this.$refs.vehicleInfoModalRef.visible = true;
    // },
    // 输入车牌号查询系统中是否已存在该车辆信息，并赋值
    handleQueryLicensePlateNo() {
        // this.isExistVehicleInfo = false;
        // if (this.formData.licensePlateNo) {
        //     getSysLicensePlateNo(this.formData.licensePlateNo).then(res => {
        //         if (res && res.data && +res.code === 0) {
        //             // // 如果系统数据库中存在该车辆信息且行驶证有效，显示提示语`车辆信息已存在系统中`
        //             // this.isExistVehicleInfo = !!res.data.sysLicensePlateNo && res.data.carDrivingFileStatus === '0';
        //             this.vehicleInfo = res.data || {}
        //         }
        //     })
        // }

        if (!this.formData.licensePlateNo) {
            return false
        }

        this.$refs.formRef.validateField('licensePlateNo', errMsg => {
            // errMsg 判断校验不通过
            // 再次判断 licensePlateNo 是否为空，处理输入车牌后，焦点还在输入框时，点击关闭会再次以空车牌号请求问题
            if (errMsg || !this.formData.licensePlateNo) {
                return false
            }
            getSupplierCarInfoDetail(this.formData.licensePlateNo)
                .then(res => {
                    if (res && +res.code === 0) {
                        // 查到数据覆盖内外径长宽高
                        if (res.data) {
                            // this.innerDiameterData.insideLength = res.data.insideLength
                            // this.innerDiameterData.insideWidth = res.data.insideWidth
                            // this.innerDiameterData.insideHeight = res.data.insideHeight
                            this.formData.insideLength = res.data.insideLength
                            this.setOcrAndChangeType('insideLength', res.data.insideLength, 'systemValue')
                            this.formData.insideWidth = res.data.insideWidth
                            this.setOcrAndChangeType('insideWidth', res.data.insideWidth, 'systemValue')
                            this.formData.insideHeight = res.data.insideHeight
                            this.setOcrAndChangeType('insideHeight', res.data.insideHeight, 'systemValue')
                            // this.formData.lengthInteriorLength = res.data.lengthInteriorLength
                            // this.setOcrAndChangeType('lengthInteriorLength', res.data.lengthInteriorLength, 'systemValue')
                            // this.formData.lengthInteriorWidth = res.data.lengthInteriorWidth
                            // this.setOcrAndChangeType('lengthInteriorWidth', res.data.lengthInteriorWidth, 'systemValue')
                            // this.formData.lengthInteriorHeight = res.data.lengthInteriorHeight
                            // this.setOcrAndChangeType('lengthInteriorHeight', res.data.lengthInteriorHeight, 'systemValue')
                        }
                        // else {
                        //     this.innerDiameterData.insideLength = null
                        //     this.innerDiameterData.insideWidth = null
                        //     this.innerDiameterData.insideHeight = null
                        // }
                    }
                })
                .catch(err => {})
        })
    },
    // 处理请求参数
    dealWithReqParams() {
        const formData = JSON.parse(JSON.stringify(this.formData))
        formData.supplierCode = this.$route.query.supplierCode
        formData.tenantCode = this.$store.state.currentTenant.tenantCode
        const isSupplier = this.$store.state.supplier
        const supplierCode = isSupplier ? isSupplier.supplierCode : this.$route.query.supplierCode
        formData.supplierCode = supplierCode
        ;['lengthMaxWeight', 'grossWeight', 'totalWeight', 'insideLength', 'insideWidth', 'insideHeight'].forEach(k => {
            formData[k] = Number(formData[k])
        })
        // 其他信息转化为逗号连接的字符串
        formData.otherInformation =
            formData.otherInformation && formData.otherInformation.length ? formData.otherInformation.join(',') : ''
        // 来源渠道
        formData.createSystemSource = isSupplier ? REGISTER_SOURCE.LSP : REGISTER_SOURCE.LSRM
        // 超牌到期日期
        formData.trailerDrivingEndDate = this.tdeVisible
            ? dayjs(formData.trailerDrivingEndDate).format('YYYY-MM-DD')
            : ''
        formData.businessType = this.supplierTab.businessType || null
        formData.paramFieldList = Object.keys(this.ocrResultMap).map(k => {
            const beforeValue = k === 'otherInformation' ? (this.backupFormData[k] + '') : this.backupFormData[k]
            return {...this.ocrResultMap[k], beforeValue: this.id ? beforeValue : ''}
        })
        return formData
    },
    isEmpty(v){
        return ['', undefined, null].includes(v)
    },
    setChangeType(){
        //提交时需要对比前后值的变化 changeType: 1-ocr,2-system,3-人工
        Object.keys(this.ocrResultMap).forEach(k => {
            if(k === 'otherInformation'){
                if(this.backupFormData[k].length === this.formData[k].length && this.backupFormData[k].every((item, idx) => this.formData[k].includes(item))){
                    if(['30', '80'].includes(this.backupFormData.approvalStatus)){
                        //如果是撤回/驳回状态，不用设置changeType,用初始化的值
                    }else{
                        this.ocrResultMap[k].changeType = '2'
                    }
                }else{
                    this.ocrResultMap[k].changeType = '3'
                }
            }else{
                const isSame = (this.formData[k] == this.backupFormData[k]) || (this.isEmpty(this.formData[k]) && this.isEmpty(this.backupFormData[k]))
                if(['30', '80'].includes(this.backupFormData.approvalStatus) && isSame){
                    //如果是撤回/驳回状态并且值没有变化，那么不用设置changeType,用初始化的值
                    if(this.ocrResultMap[k].changeType === '3'){
                        //如果是人工，需要避免卡控
                        this.ocrResultMap[k].noCheck = true
                    }
                    return
                }


                if(this.ocrResultMap[k].ocrValue){
                    //如果有OCR识别结果
                    if(this.ocrResultMap[k].ocrValue == this.formData[k]){
                        //OCR值与表单值一致
                        this.ocrResultMap[k].changeType = '1'
                    }else{
                        this.ocrResultMap[k].changeType = '3'
                        this.ocrResultMap[k].noCheck = false
                    }
                }else{
                    //没有OCR识别结果
                    if((this.formData[k] == this.backupFormData[k]) || (this.isEmpty(this.formData[k]) && this.isEmpty(this.backupFormData[k]))){
                        //值相同，则把changeType改为system
                        this.ocrResultMap[k].changeType = '2'
                    }else if(this.ocrResultMap[k].systemValue){
                        //有system自动赋值过
                        if(this.ocrResultMap[k].systemValue == this.formData[k]){
                            //systemValue值与表单值一致
                            this.ocrResultMap[k].changeType = '2'
                        }else{
                            this.ocrResultMap[k].changeType = '3'
                            this.ocrResultMap[k].noCheck = false
                        }
                    }else{
                        //前后值不一致并且没有system赋值
                        this.ocrResultMap[k].changeType = '3'
                        this.ocrResultMap[k].noCheck = false
                    }
                }
                if(['totalWeight', 'lengthMaxWeight', 'lengthInteriorLength', 'lengthInteriorWidth'].includes(k) && this.ocrResultMap[k].systemValue === this.formData[k]){
                    //1、为了应对OCR自动计算赋值([总质量]=核定载重量+整备质量) 当systemValue与表单值一致，则改为system，
                    //2、当车辆类型含有牵引时，核定载重量自动取准牵引总质量 当systemValue与表单值一致，则改为system
                    //3、当车辆类型含有牵引时，外径长度 = 车头外径长+挂车外径长，当systemValue与表单值一致，则改为system
                    //4、当车辆类型含有牵引时，外径宽度 = 挂车外径长，当systemValue与表单值一致，则改为system
                    this.ocrResultMap[k].changeType = '2'
                }

            }
        })
        //行驶证改变了
        if(this.formData.carDrivingFileUrl !== this.backupFormData.carDrivingFileUrl){
            //车牌号的ocrValue与表单值对比
            ['licensePlateNo'].forEach(k => {
                if(this.ocrResultMap[k].ocrValue === this.formData[k]){
                    //对比一致时，编辑属于system，新建属于ocr
                    this.ocrResultMap[k].changeType = this.id ? '2' : '1'
                }else{
                    //对比不一致时，编辑属于system高风险，新建属于人工高风险
                    this.ocrResultMap[k].changeType = this.id ? '4' : '5'
                }
            })
        }
    },
    checkCredentialDate() {
        let flag = true
        let licenseNameList = []
        //针对特定OCR字段，如果人工修改后没有重新上传对应的证件图片，需要卡控
        const validateList = this.validateOcrData.reduce((t, v) => {
            // if(v.field === 'carDrivingEndTime'){
            //     const isSame1 = (this.backupFormData[v.fileProp[0]] === this.formData[v.fileProp[0]] || (this.isEmpty(this.backupFormData[v.fileProp[0]]) && this.isEmpty(this.formData[v.fileProp[0]])))
            //     const isSame2 = (this.backupFormData[v.fileProp[1]] === this.formData[v.fileProp[1]] || (this.isEmpty(this.backupFormData[v.fileProp[1]]) && this.isEmpty(this.formData[v.fileProp[1]])))
            //     if(this.ocrResultMap[v.field].changeType === '3' && isSame1 && isSame2){
            //         console.log('修改前：',this.backupFormData[v.field],'修改后：',this.formData[v.field],'修改前url：',this.backupFormData[v.fileProp],'修改后url：',this.formData[v.fileProp],'字段：',v.label)
            //         t.push(v.label)
            //     }
            // }else{
                if(this.ocrResultMap[v.field].changeType === '3' && !this.ocrResultMap[v.field].noCheck && (this.backupFormData[v.fileProp] === this.formData[v.fileProp] || (this.isEmpty(this.backupFormData[v.fileProp]) && this.isEmpty(this.formData[v.fileProp])))){
                    console.log('修改前：',this.backupFormData[v.field],'修改后：',this.formData[v.field],'修改前url：',this.backupFormData[v.fileProp],'修改后url：',this.formData[v.fileProp],'字段：',v.label)
                    t.push(v.label)
                    licenseNameList.push(v.licenseName)
                }
            // }
            
            return t
        }, [])
        if(validateList.length){
            this.$message.warning(`您修改了${validateList.join('、')}，请重新上传${[...new Set(licenseNameList)].join('、')}。`)
            flag = false
        }
        return flag
    },
    validateForm(fn) {
        // if (!this.formData.carDrivingFileUrl) {
        //     return this.$message.warning('请上传行驶证正副面');
        // } else if (!this.formData.carDrivingBottomFileUrl) {
        //     return this.$message.warning('请上传行驶证正副背面');
        // }
        let requiredValid = true
        uploadList.forEach(item => {
            if(!requiredValid) return
            if(['trafficInsuranceFileUrl', 'businessInsuranceFileUrl'].includes(item.fileUrl) && this.insuranceRequired && !this.formData[item.fileUrl]){
                requiredValid = false
                return this.$message.warning(`请上传${item.label}`)
            }
            if (requiredValid && item.isRequired && !this.formData[item.fileUrl]) {
                requiredValid = false
                return this.$message.warning(`请上传${item.label}`)
            }
        })
        if (!requiredValid) {
            return
        }

        if(this.hasTract && (!this.formData.trailerDrivingFileUrl || !this.formData.trailerDrivingVerifyFileUrl)){
            return this.$message.warning('当车辆类型为牵引车时，必须上传挂车行驶证正副页与年审页！')
        }

        // 0509司机注册需求：要求去掉校验
        // if (!this.isLegalPersonSupplier) {
        //     if (this.formData.carOwnerType === CAR_OWNER_TYPE['TEMPORARY']) {
        //         return this.$message.warning('个体物流供应商车辆归属不能为临时!')
        //     }
        // }
        Promise.resolve(this.$refs.formRef.validate())
            .then(() => {
                this.setChangeType()
                if (!this.checkCredentialDate()) {
                    return false
                }
                if (this.approvalStatus && this.approvalStatus !== AUDIT_STATUS.ADOPT) {
                    fn(this.dealWithReqParams(), true)
                } else if (this.ocrHasChange()) {
                    // this.$confirm(
                    //     '您修改了“车牌号、车辆所有人、车辆能源类型、核定载重、整备质量、行驶证检验有效期”信息，需提交审批',
                    //     '提示',
                    //     {
                    //         confirmButtonText: '提交审批',
                    //         cancelButtonText: '取消',
                    //         type: 'info',
                    //     },
                    // )
                    //     .then(() => {
                            fn(this.dealWithReqParams(), true)
                        // })
                        // .catch(() => {})
                } else {
                    fn(this.dealWithReqParams(), false)
                }
            })
            .catch(err => {
                console.warn(err)
                this.$message.warning('必填项未维护完整，请仔细检查')
            })
    },
    // // 将识别出来的系统信息赋值给表单数据
    // handleSetFormData() {
    //     this.setFileData(this.vehicleInfo);
    //     Object.keys(this.vehicleInfo).forEach(k => {
    //         if (k === 'relationId') { return; }
    //         this.formData[k] = this.vehicleInfo[k] ? this.vehicleInfo[k] + '' : '';
    //     });
    //     // 设置能源类型
    //     if (this.vehicleInfo.inspectionRecord) {
    //         this.setEnergyType(this.vehicleInfo.inspectionRecord);
    //     }
    //     this.isExistVehicleInfo = false;
    // },
    // 重置表单数据
    resetForm() {
        if (this.$refs.formRef) {
            this.$refs.formRef.resetFields()
            // this.isExistVehicleInfo = false;
            // this.vehicleInfo = {}
            this.fileObj = {}
            ;[
                'carDrivingFileUrl',
                'carDrivingBottomFileUrl',
                'roadTransportFileUrl',
                'affiliatedFileUrl',
                'trafficInsuranceFileUrl',
                'businessInsuranceFileUrl',
                'trailerDrivingFileUrl',
                'trailerDrivingVerifyFileUrl',
            ].forEach(k => (this.uploadForm[k] = ''))
            Object.keys(this.formData).forEach(k => {
                this.formData[k] = k === 'otherInformation' ? [] : ''
            })
        }
        // // 重置内径作对比的数据
        // this.innerDiameterData = {
        //     insideLength: null,
        //     insideWidth: null,
        //     insideHeight: null,
        // }
    },
    handlecarOwnerChange(val) {
        // 根据法人或个体，车辆所有人与供应商名称还是负责人姓名来作比较
        const validName = this.isLegalPersonSupplier ? this.supplierName : this.principalName
        // 车辆所有人与供应商名称不一样时，将车辆归属为'自有' 1 清空；车辆所有人与供应商名称一样时，车辆归属无值时将其设为'自有' 1；
        if (validName !== val && this.formData.carOwnerType === CAR_OWNER_TYPE.OWN) {
            this.formData.carOwnerType = ''
        } else if (
            (validName === val && !this.formData.carOwnerType)
            || (this.isLegalPersonSupplier && this.supplierName === val)
        ) {
            this.formData.carOwnerType = CAR_OWNER_TYPE.OWN
        }
        this.$refs.formRef.validateField('carOwnerType')
    },
    getMainVehicleType(data) {
        this.$set(this.formData, 'mainVehicleType', data)
    },
    // 内径高输入回调
    handleInhChange(val) {
        this.$refs.formRef.validateField('insideHeight', errMsg => {
            // errMsg 判断校验不通过
            if (errMsg) {
                this.innerHeightTipVisible = false
                clearTimeout(this.innerHeightTipTimeout)
                return false
            }
            if (+val >= 3 && +val <= 3.2) {
                this.innerHeightTipVisible = true
                this.innerHeightTipTimeout = setTimeout(() => {
                    this.innerHeightTipVisible = false
                }, 2000)
            } else {
                this.innerHeightTipVisible = false
                clearTimeout(this.innerHeightTipTimeout)
            }
        })
    },
    // // 对比内径长宽高是否进行了变更
    // checkInnerDiameter() {
    //     return (
    //         this.innerDiameterData.insideLength !== this.formData.insideLength
    //         || this.innerDiameterData.insideWidth !== this.formData.insideWidth
    //         || this.innerDiameterData.insideHeight !== this.formData.insideHeight
    //     )
    // },
    handleCheckBoxChange(val, prop) {
        this.formData[prop] = val
    },
}
